<template>
  <div class="puck_up">
    <yd-button @click.native="AddPuckUp()" class="add">添加接机信息</yd-button>
    <yd-preview :buttons="[]" v-for="(meet,index) of MeetList" :key="index">
      <yd-preview-header>
        <div slot="left">
          参会人
        </div>
        <div slot="right" style="font-size: .28rem;">
          <div v-for="(rel,index) in meet.exhJiejiRel" :key="index">
            {{rel.contact.user_name}}  {{rel.contact.mobile_phone}}
          </div>
        </div>
      </yd-preview-header>
      <yd-preview-item>
        <div slot="left">{{meet.jieji_zhan_name?meet.jieji_zhan_name:''}}</div>
        <div slot="right"></div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">{{meet.jieji_time?meet.jieji_time:''}}</div>
        <div slot="right"></div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left" class="edit"><a :href="'/' + params.id + '/meet-update/' + meet.id">编&nbsp;辑</a></div>
        <div slot="right"></div>
      </yd-preview-item>
    </yd-preview>
  </div>
</template>

<script type="text/babel">
import axios from 'axios'

export default {
  data () {
    return {
      MeetList: [],
      params: this.$route.params
    }
  },
  methods: {
    getMeet () {
      let that = this
      let data = {uid: this.$store.state.uid, fair_id: this.params.id}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/fair/meet-list', data)
        .then(this.getMeetSucc)
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    getMeetSucc (res) {
      res = res.data
      if (res.status && res.data) {
        this.MeetList = res.data
      }
    },
    HistoryBack () {
      window.history.back()
    },
    AddPuckUp () {
      this.$router.push({path: 'meet-create'})
    },
    checkLogin () {
      if (!this.$store.state.uid) {
        this.$router.push({path: '/' + this.params.id + '/single-my'})
      }
    }
  },
  mounted () {
    this.checkLogin()
    this.getMeet()
  }
}
</script>

<style lang="stylus" scoped>
  .add
    width: 1.5rem
    left: .24rem

  .puck_up
    width: calc(100% - .4rem)
    margin: 0 auto
    background-color: #fff
    margin-top: .2rem
    padding: .2rem 0
    border-radius: .2rem

  .edit
    text-align-last: center
    padding: .04rem .2rem
    border: solid .02rem #00C800
    border-radius: .04rem

  .edit a
    color: #00C800

  .yd-preview-item:last-child
    padding-bottom: 0
</style>



// WEBPACK FOOTER //
// src/views/template1/PuckUp.vue